import { render } from "./TeacherSubjectAddingDialog.vue?vue&type=template&id=376063d4&scoped=true"
import script from "./TeacherSubjectAddingDialog.vue?vue&type=script&lang=js"
export * from "./TeacherSubjectAddingDialog.vue?vue&type=script&lang=js"

import "./TeacherSubjectAddingDialog.vue?vue&type=style&index=0&id=376063d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-376063d4"]])

export default __exports__